export default "__VITE_ASSET__D_VdXYb___"